import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=e0b104c6&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=e0b104c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b104c6",
  null
  
)

export default component.exports